import gql from 'graphql-tag';

export const NAME =
  'compositions_CaseBillingPanel_updateCaseBillingInfoMutation';

export default gql`
  mutation ${NAME} ($caseId: ID!, $billingInfo: BillingInfoParams!) {
    updateCase(
      input: {
        id: $caseId,
        patch: { billingInfo: $billingInfo },
      },
    ) {
      case {
        id
        fixpixPushResult
        billingInfo {
          amount
          comment
          poNumber
          woNumber
          ticketNumber
          invoiceNumber
          referenceNumber
          contractNumber
          releaseNumber
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseBillingPanel/updateCaseBillingInfoMutation.js